import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchProposeCandidates,
  setProposedListCandidatesLoading,
  updateProposedFilters,
  updateProposedPagination,
} from "@/reducers/clientunfilledcontracts";
import { getIsFilterApplied } from "@/utilities/utils";

import { deSelectShortListAllCandidate } from "../../../../../reducers/clientcreatejob";
import TableSearch from "../../dataTables/TableSearch";

const SearchFilterModal = () => {
  const { proposedFilters, pagination, proposedPagination } = useSelector(
    (state) => state.clientUnfilledContracts,
  );
  const filterApplied = getIsFilterApplied(proposedFilters);
  const dispatch = useDispatch();
  const handleSearch = (e) => {
    dispatch(updateProposedFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setProposedListCandidatesLoading(true));
      dispatch(
        updateProposedPagination({
          ...proposedPagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(deSelectShortListAllCandidate());
      dispatch(fetchProposeCandidates(proposedFilters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [proposedFilters.search]);
  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={proposedFilters.search} handleChange={handleSearch} />
      </div>
    </div>
  );
};

export default SearchFilterModal;
